<template>
  <div>
    <h1>欢迎来到我们的支持页面</h1>
    <button @click="initiateChat">开始聊天</button>
  </div>
</template>

<script>
export default {
  methods: {
    initiateChat() {
      // 定义自定义变量
      window.__lc = window.__lc || {};
      window.__lc.params = {
        user_id: '12345',
        user_name: '张三',
        user_email: 'zhangsan@example.com'
      };

      // 启动聊天
      // 确保您在这里根据需要打开聊天窗口
      window.LC_API.open_chat_window();
    }
  }
};
</script>
